function formRedeemMerchant() {
  const form = $('.form-redeem-voucher-merchant')
  const input = form.find('.input-redeem-quantity')
  const plusButton = form.find('.plus')
  const minusButton = form.find('.minus')

  const verifyValueButton = val => {
    const max = parseInt($('.form-redeem-voucher-merchant').find('.input-redeem-quantity').attr('max'))
    if (val >= max) {
      plusButton.addClass('disabled')
      plusButton.addClass('text-muted')
    } else {
      plusButton.removeClass('disabled')
      plusButton.removeClass('text-muted')
    }
    if (val <= 1) {
      minusButton.addClass('disabled')
      minusButton.addClass('text-muted')
    } else {
      minusButton.removeClass('disabled')
      minusButton.removeClass('text-muted')
    }
  }

  input.on('change-maximum', function() {
    verifyValueButton(parseInt(input.val()))
  })

  input.on('keypress', function(e) {
    const val = parseInt($(e.currentTarget).val())
    const max = parseInt($('.form-redeem-voucher-merchant').find('.input-redeem-quantity').attr('max'))
    if (val >= max) {
      e.preventDefault()
      e.stopPropagation()
    }
    verifyValueButton(val)
  })

  plusButton.on('click', function(e){
    e.stopPropagation()
    e.preventDefault()
    const val = parseInt(input.val())
    const max = parseInt($('.form-redeem-voucher-merchant').find('.input-redeem-quantity').attr('max'))
    if (val >= max) {
      return false
    }
    input.val(val + 1)
    verifyValueButton(parseInt(input.val()))
  })

  minusButton.on('click', function(e) {
    e.stopPropagation()
    e.preventDefault()
    const val = parseInt(input.val())

    if (val > 1) {
      input.val(val - 1)
    }

    verifyValueButton(parseInt(input.val()))
  })

  verifyValueButton(parseInt(input.val()))
}

$(document).ready(function() {
  $('.voucher-radio').each(function(_idx, elm) {
    $(elm).attr('disabled', false)
  })

  $('.voucher-radio').on('click', function() {
    $('.btn-confirm-redeem').attr('disabled', false)
  })

  formRedeemMerchant()

  $('.btn-confirm-redeem').on('click', function(){
    if ($('.voucher-radio:checked').length > 0) {
      let dataVoucher = JSON.parse($('.voucher-radio:checked').data('voucher'))

      $('#redeem-voucher-selected').find('#target-voucher-id-input').val(dataVoucher.id)
      $('#redeem-voucher-selected').find('#target-user-voucher-id-input').val(dataVoucher.user_voucher_id)
      $('#redeem-voucher-selected').find('#target-voucher-name').html(dataVoucher.name)
      $('#redeem-voucher-selected').find('#target-voucher-image img').attr('src', dataVoucher.image)
      $('#redeem-voucher-selected').find('#target-voucher-quantity').html(dataVoucher.quantity)
      $('#redeem-voucher-selected').find('#voucher-quantity').attr('max', dataVoucher.quantity)
      let currentQty = parseInt($('#redeem-voucher-selected').find('#voucher-quantity').val())
      if (currentQty > parseInt(dataVoucher.quantity)){
        $('#redeem-voucher-selected').find('#voucher-quantity').val(dataVoucher.quantity)
      }
      $('#redeem-voucher-selected').find('#voucher-quantity').trigger('change-maximum')
    }
  })

  if (document.querySelectorAll('input[type=radio][class*=user_voucher_id-]').length > 0) {
    document.querySelectorAll('input[type=radio][class*=user_voucher_id-]').forEach(el => {
      el.addEventListener('change', () => {
        let target     = el.classList[el.classList.length - 1]
        var dataTarget = document.getElementById(target)
        if (el.checked) {
          document.querySelectorAll('[id*=user_voucher_id-]').forEach(e => {e.classList.add('d-none')})
          if (dataTarget != null) {
            dataTarget.classList.remove('d-none')
          }
        } else {
          document.querySelectorAll('[id*=user_voucher_id-]').forEach(e => {e.classList.remove('d-none')})
          if (dataTarget != null) {
            dataTarget.classList.add('d-none')
          }
        }
      })
    })
  }
})
